<template>
<div class="evan-footer" data-html2canvas-ignore ref="pageFooter">

  <div class="page-footer">

    <div class="info-line" ref="driverInfo">

      <div>旅途向导者©2025-{{currentTime | dateformat('yyyy')}} 静态网站{{getLastVersion().title}}&thinsp;<span style="color: var(--active-color)" @click="$router.push('/user-agreement')">用户协议&thinsp;<i class="iconfont icon-to-link"></i></span></div>
      <div data-html2canvas-ignore style="display: flex;flex-direction: row;justify-content: center;align-items: center;flex-wrap: wrap;gap: .5em">
        <a class="icpInfo" href="https://www.lijun.space" target="_blank">
          <van-image :src="logoImage" s="https://cdn4.winhlb.com/2025/10/08/68e55701dbc3f.png" class="icp-image"></van-image>
          <span class="icp-number">访问主站<i class="iconfont icon-to-link generate-image-bills"></i></span>
        </a>
        <span class="icpInfo" @click="goToIcp" >
          <van-image :src="icpImage" class="icp-image"></van-image>
          <span class="icp-number">豫ICP备2025112832号 <i class="iconfont icon-to-link generate-image-bills"></i></span>
        </span>
        <a class="icpInfo e_flex-r-jc:fs-ai:c" style="gap: .2em" href="https://yuanbao.tencent.com/chat/naQivTmsDa" target="_blank">
          <evan-icon icon="icon-yuanbao" svg></evan-icon>
          <span class="icp-number">腾讯元宝提供支持 <i class="iconfont icon-to-link generate-image-bills"></i></span>
        </a>
      </div>
      <div data-html2canvas-ignore class="is-row_space-between footer-last-line" >

        <a class="icpInfo generate-image-bills" href="mailto:2236191873@qq.com?body=来自网站bills" target="_blank">
          <span class="icp-number">联系作者<i class="iconfont icon-mail "></i></span>
        </a>
        <div v-if="haveUpdate" :class="haveUpdate?'haveUpdate':''" @click="$router.push('development-logs')">有更新<i class="iconfont icon-times"></i></div>
        <div>{{currentTime|dateformat('YY/MM/DD HH:mm:ss')}}</div>
      </div>

    </div>
  <div style="width: 100%;height: .5em;display: none"></div>
  </div>

</div>
</template>

<script>
import {getLastVersion} from "@/utils/DevelopmentLog";
import {GetTime} from "@/utils/mixin/getTime";
import EvanIcon from "@/components/EvanIcon.vue";
import {images} from "@/assets/images";

export default {
  name: "EvanFooter",
  components: {EvanIcon},
  mixins: [GetTime],

  computed: {
    haveUpdate() {
      let ver = this.$store.state.appVersion;
      console.log(ver,getLastVersion().title,ver===getLastVersion().title)
      return !ver || (getLastVersion().title!==ver)
    },
  },
  data() {
    return{
      currentTime: '',
      logoImage: images.logo,
      icpImage:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAEOElEQVR4AWySf2hVZRjHP+c959zdu3uv27QrzqnZUpdm+WMZDh0zZYGBmuAqi1KQDNJREJiUWEHRaikphWFZmWIaofkDLNFME3GylSHlj4niNrelXtnd2t3uOec9p+eaXvZHL+/D833vfd/P832f9yj+Z1x9iKJrk6htn8SmYBZWezmj2sZzuLWMI9ntAajmMeRJNrLrgZEDZv/smMKEnkoSsXyiZpQKFWPaDZv77DiVZpyLZoz+K7MIt4xldsjjrdaRlA6EZXUO2DadR40wu/pMNjGYQaEiWkIFDLfz+NGKsT5vCPPsIqZFoU7WlSrMIiIMz0IGhrq7UDauuPLsCB1WiC9Mm9etMMWiR5gWtmRlh9FmHitChSyxiti8oXz5OT66OoE3z5Tw9qlBEBgqe4Ubj1Elm3tCYbYIZKHAKuwQnm1zVGCrJV4wDeYbBguVSZ0KEZb9S6szTaPw1XjMvA9IW5+z8kSVyteMk85ul8PPKZsVyqJEgFog2wKDJZHv+Dj6PQeiP9BUsJ9T0pL3DZNvDJvxU1ICTI/Yi+ucxtML0M4uJZVdbLYKrFSZ3CtAJC4YFp/l76SVWuLZB7vbmkyPeBL3skfbFi405KO9yWgdQvuGGnKc84ElFRWjpXJEKTxT8fOtoQ//mVkZegDNYmpQ3BnFxVSbJovEwJGUmWjCi76E74s7T+oGb6ibs2iwDOoNRcKQu0v2AoOW+U80jvmtZM4C8uQla6DzeaLeUg4I+ku5STII2WvGVpxcRcA7AiySXAeZHUrEMCk+GANH8n/TwAgCo6A5PjHfx3qaY5wdGqExo+zSPwZNfqVgeuvqwmmX13lBUIsOLoGq4dPKNWyel1aWYh4+6wR8KciaDrCMgNKZ7Xva68ve65pa1b5n4sy2b++f0bJj5IxrP1VOOvyMb1nbpGQHQbBWPqTHWf/IbuQHZKjCKs4K7Ezg0xxo+nyNpX1mf3joqZJ8t2dL2ogcTFpFjd324JYMoYPKDdYLsBo/spy14+qof7CTOzBkqOuHGa0znPQyjBRY0vfAdxnj+yw7tnPIsIu/x0901kQPJp+Nbe1dVniovzbxS/By4mJyd8L4u8KYc76MuHByU3W73BTQRu1yXPJmyT0ShsRiP8P+vnO81ruIub01lPc+SXlqLtNvzeFFnccqDOJlF0jnaCLU2Aa6E72su8fia7dPXjLDUYH95TpYnss40e9qzXbPYZ/jsc/z2SOFX9V9hN0uYgZo4eTm7e/LaMK9liTm9TJbp5nq9LFBO9RLK9rcDNdFa9G27gevn/1uDxu9bqplXZMj3RG3gVldcppbgcNKOVDXlWKn00WzOLgsh/e5LkucFNudJKfcFHudNHt9h0+0R3327MDIAcV6UNzI6WENbMq2gX463H9Iud04iQIOCfCm3GCiuOocfY6Or66wpbSVXwfCsvpfAAAA///v+/I5AAAABklEQVQDAIbVwoDhZkO+AAAAAElFTkSuQmCC',

      activeDevLog: '',
    }
  },methods: {
    getLastVersion,
    handleFooterResize() {

    },
    goToIcp() {
      this.$CF.copyText('豫ICP备2025112832号', '备案号', '', false);
      setTimeout(() =>{
        window.open('https://beian.miit.gov.cn/#/Integrated/index');
      },500)
    },
  },mounted() {
    var pageFooter = this.$refs.pageFooter;
    console.log(pageFooter.offsetWidth,pageFooter.offsetHeight,pageFooter)
    this.$store.commit('commitValue',{key:'footerWidth', value: pageFooter.offsetWidth})
    this.$store.commit('commitValue',{key:'footerHeight', value: pageFooter.offsetHeight})
  }
}
</script>

<style lang="scss">
.haveUpdate{
  transition: none !important;
  animation: update-blink 1s infinite; /* 应用动画，1秒循环，无限重复 */
}
@keyframes update-blink {
  0%, 50% { color: var(--footer-color); }  /* 前半段时间完全显示 */
  51%, 100% { color: var(--primary-color); } /* 后半段时间完全隐藏 */
}
.evan-footer {
  width: 100%;
  text-align: center;
  font-size: .5em;
  outline: none;
  box-sizing: border-box;
  color: var(--footer-color);
  & *{
    user-select: none;
  }
}
.page-footer{

  padding-top: 2em;
  border-top: 2px solid var(--negative-color);
  background-color: var(--solid-color);
}


.footer-last-line {
  //padding: .5em;
  outline: none;
  box-sizing: border-box;
}

.info-line {
  font-size: 11px;
  color: var(--footer-color);
  padding: 1em .3em;
  line-height: 1.2;
  white-space: pre-wrap;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: .5em;
}

.info-line strong {
  color: var(--primary-color);
}
</style>
